import AppDataService from "./AppDataService";

const COMMON_BASE = 'signup'

export default class OnboardingDataService {
    static async getSignUpFormOptions(){
        return await AppDataService.get(`${COMMON_BASE}/GetSignUpFormOptions`, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async saveOnboardingData(onboardingData){
        return await AppDataService.post(`${COMMON_BASE}/OnboardingDetails`, onboardingData, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
}